export default {
    data() {
        return {
            cdEmpresa: 0,
            cdPessoa: 0,
            cdCredor: 0,
            cdProduto: 0,
            cdDivida: 0,
            SqDivida: 1
        }
    },
    methods: {
        DividaArray(divida) {
            if ((typeof divida === 'undefined' ? 'undefined' : typeof divida) === 'object') {
                this.cdEmpresa = divida.cdEmpresa;
                this.cdPessoa = divida.cdPessoa;
                this.cdCredor = divida.cdCredor;
                this.cdProduto = divida.cdProduto;
                this.cdDivida = divida.cdDivida;
                this.SqDivida = 1;
            } else if ((typeof divida === 'undefined' ? 'undefined' : typeof divida) === 'string') {
                try {
                    //Chave divida no formato texto Deverá ter 21 caracteres
                    if (divida.length !== 21) {
                        throw new Error('Chave divida inválida. ');
                    } else {
                        this.cdPessoa = parseInt(divida.substring(0, 8))
                        this.cdEmpresa = parseInt(divida.substring(8, 10))
                        this.cdCredor = parseInt(divida.substring(10, 13))
                        this.cdProduto = parseInt(divida.substring(13, 16))
                        this.cdDivida = parseInt(divida.substring(16, 21))
                        this.SqDivida = 1
                    }
                } catch (err) {
                    throw new Error('Não foi possível carregar a divida. ');
                }
            }
            var array = [this.cdEmpresa, this.cdPessoa, this.cdCredor, this.cdProduto, this.cdDivida, this.SqDivida];
            return array;
        },
        DividaBase64(divida) {
            return btoa(this.DividaArray(divida).join("|"));
        },
        Divida(divida) {
            return this.DividaArray(divida).join("|");
        }
    },
}